import React from 'react'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

interface ItemProps {
  children: React.ReactNode,
  icon: React.ReactNode,
  label: string,
}

const Item = (props: ItemProps) => {
  const {
    children, icon, label,
  } = props

  return (
    <Box>
      <ListItem
        boxProps={{
          alignItems: 'center',
          padding: 'large',
          borderRight: '1px solid',
          borderColor: 'lineColor',
        }}
        disableHover
      >
        {icon && (
          <Box color="lightGrey" marginRight="large" width="auto">
            {icon}
          </Box>
        )}

        <Box flexDirection="column">
          <Text color="bodyFontLightColor" fontSize="xsmall" marginBottom="small">
            {label}
          </Text>

          <Text fontSize="medium">
            {children}
          </Text>
        </Box>
      </ListItem>
    </Box>
  )
}

export default Item
